import './DesignerPrompt.less';
import { EnabledPrompt, IEnabledPromptProps } from './EnabledPrompt';
import { IInputDataPromptProps, InputDataPrompt } from './InputDataPrompt';
import { IIntegrationPromptProps, IntegrationPrompt } from './IntegrationPrompt';

export interface IDesignerPromptProps {
  inputDataProps?: IInputDataPromptProps;
  integrationProps?: IIntegrationPromptProps;
  enabledProps?: IEnabledPromptProps;
}

export function DesignerPrompt({ inputDataProps, integrationProps, enabledProps }: IDesignerPromptProps) {
  return (
    <div className="dp-designer-prompt">
      {inputDataProps && <InputDataPrompt {...inputDataProps} />}
      {enabledProps && <EnabledPrompt {...enabledProps } />}
      {enabledProps && integrationProps && <div className='dp-designer-prompt__separator'/>}
      {integrationProps && <IntegrationPrompt {...integrationProps} />}
    </div>
  );
}
